import type { RouteObject } from 'react-router-dom';

import { lazy, Suspense } from 'react';

const SharedConversationPage = lazy(() =>
  import('./pages/shared-conversation-page').then((m) => ({
    default: m.SharedConversationPage,
  })),
);

// `/share/:shareId` is a PUBLIC, top-level route — it must be registered
// OUTSIDE ProtectedRoute (a shared conversation is viewable without auth).
// The path is absolute: this route has no parent layout to resolve against.
export const shareRoutes: RouteObject[] = [
  {
    path: '/share/:shareId',
    element: (
      <Suspense fallback={null}>
        <SharedConversationPage />
      </Suspense>
    ),
  },
];
